/*
 * This file is part of the Sylius package.
 *
 * (c) Paweł Jędrzejewski
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import 'semantic-ui-css/components/api';
import 'semantic-ui-css/components/checkbox';

const createRootContainer = function createRootContainer() {
  return $('<div class="ui taxonomy-dynamic-list"></div>');
};

const createRootTabHeadersContainer = function createRootTabHaeadersContainer() {
  return $('<div class="ui top attached tabular menu taxonomy-dynamic-list-header"></div>');
};

const createRootTabHeader = function createRootTabHaeader(tabName) {
  return $(`<div class="item" style="cursor: pointer;" data-tab="${tabName}"></div>`);
};

const createRootTab = function createRootTab(tabName) {
  return $(`<div class="ui bottom attached tab segment taxonomy-dynamic-list-tab" data-tab="${tabName}"></div>`);
};

const createRootTabItemsContainer = function createRootTabItemsContainer() {
  return $('<div class="ui list"></div>');
};

const createLeafContainerElement = function createLeafContainerElement() {
  return $('<div class="list"></div>');
};

const createLeafIconElement = function createLeafIconElement() {
  return $('<i class="folder icon"></i>');
};

const createLeafTitleElement = function createLeafTitleElement() {
  return $('<div class="header"></div>');
};

const createLeafTitleSpan = function createLeafTitleSpan(displayName) {
  return $(`<span style="margin-right: 5px; cursor: pointer;">${displayName}</span>`);
};

const createLeafContentElement = function createLeafContentElement() {
  return $('<div class="content"></div>');
};

$.fn.extend({
  choiceTree(type, multiple, defaultLevel) {
    const tree = this;
    const loader = tree.find('.dimmer');
    const loadedLeafs = [];
    const $input = tree.find('input[type="hidden"]');

    const createCheckboxElement = function createCheckboxElement(name, code, multi) {
      const chosenNodes = $input.val().split(',');
      let checked = '';
      if (chosenNodes.some(chosenCode => chosenCode === code)) {
        checked = 'checked="checked"';
      }
      if (multi) {
        return $(`<div class="ui checkbox" data-value="${code}"><input ${checked} type="checkbox" name="${type}"></div>`);
      }

      return $(`<div class="ui radio checkbox" data-value="${code}"><input ${checked} type="radio" name="${type}"></div>`);
    };

    const isLeafLoaded = function isLeafLoaded(code) {
      return loadedLeafs.some(leafCode => leafCode === code);
    };

    const getPreLoadedNodes = function getPreloadedNodes(nodeType) {
      const preloadedNodes = tree.data(`preloaded-${nodeType}-nodes`);

      return Array.isArray(preloadedNodes) ? preloadedNodes : [];
    };

    const isNodePreloaded = function isNodePreloaded(nodeType, code) {
      return getPreLoadedNodes(nodeType).some(node => node.code === code);
    };

    const getPreloadedNode = function getPreloadedNode(nodeType, code) {
      return getPreLoadedNodes(nodeType).find(node => node.code === code);
    };

    const getPreloadedNodesFromParent = function getPreloadedNodesFromParent(nodeType, parentCode) {
      if (!isNodePreloaded(nodeType, parentCode)) {
        return null;
      }
      const parent = getPreloadedNode(nodeType, parentCode);
      const leafs = parent.children.map(childCode => getPreloadedNode(nodeType, childCode));

      return parent.children.length === leafs.length ? leafs : null;
    };

    let createLeafFunc;

    const insertLeafs = function insertLeafs(elements, parentCode, content, leafContainerElement) {
      elements.forEach((leafNode) => {
        leafContainerElement.append((
          createLeafFunc(leafNode.name, leafNode.code, leafNode.hasChildren, multiple, leafNode.level)
        ));
      });
      content.append(leafContainerElement);
      loader.removeClass('active');

      loadedLeafs.push(parentCode);

      leafContainerElement.toggle();
    };

    const loadLeafAction = function loadLeafAction(parentCode, content, icon, leafContainerElement) {
      icon.toggleClass('open');

      if (!isLeafLoaded(parentCode)) {
        const preloadedLeafs = getPreloadedNodesFromParent('leaf', parentCode);
        if (Array.isArray(preloadedLeafs)) {
          insertLeafs(preloadedLeafs, parentCode, content, leafContainerElement);
        } else {
          icon.api({
            on: 'now',
            url: tree.data('tree-leafs-url') || tree.data('taxon-leafs-url'),
            method: 'GET',
            cache: false,
            data: {
              parentCode,
            },
            beforeSend(settings) {
              loader.addClass('active');

              return settings;
            },
            onSuccess(response) {
              insertLeafs(response, parentCode, content, leafContainerElement);
            },
          });
        }
      }

      leafContainerElement.toggle();
    };

    const bindExpandLeafAction = function bindExpandLeafAction(parentCode, content, icon, level) {
      const leafContainerElement = createLeafContainerElement();
      if (defaultLevel > level) {
        loadLeafAction(parentCode, content, icon, leafContainerElement);
      }

      icon.click(() => {
        loadLeafAction(parentCode, content, icon, leafContainerElement);
      });
    };

    const bindCheckboxAction = function bindCheckboxAction(checkboxElement, nodeNameElement) {
      nodeNameElement.click(() => {
        checkboxElement.checkbox('toggle');
      });

      checkboxElement.checkbox({
        onChecked() {
          const { value } = checkboxElement[0].dataset;
          const checkedValues = $input.val().split(',').filter(Boolean);
          checkedValues.push(value);
          $input.val(checkedValues.join());
          const $checkboxElement = $(checkboxElement[0]);
          $checkboxElement.parents('.item').first().addClass('active');

          const rootNodeCode = $checkboxElement.closest('.taxonomy-dynamic-list-tab').data('tab');
          const $counter = $checkboxElement.closest('.taxonomy-dynamic-list').find(`.taxonomy-dynamic-list-counter-${rootNodeCode}`);
          $counter.text(parseInt($counter.text(), 10) + 1);
        },
        onUnchecked() {
          const { value } = checkboxElement[0].dataset;
          const checkedValues = $input.val().split(',').filter(Boolean);
          const i = checkedValues.indexOf(value);
          if (i !== -1) {
            checkedValues.splice(i, 1);
          }
          $input.val(checkedValues.join());
          const $checkboxElement = $(checkboxElement[0]);
          $checkboxElement.parents('.item').first().removeClass('active');
          const rootNodeCode = $checkboxElement.closest('.taxonomy-dynamic-list-tab').data('tab');
          const $counter = $checkboxElement.closest('.taxonomy-dynamic-list').find(`.taxonomy-dynamic-list-counter-${rootNodeCode}`);
          $counter.text(parseInt($counter.text(), 10) - 1);
        },
      });
    };

    const createLeaf = function createLeaf(name, code, hasChildren, multipleChoice, level) {
      const displayNameElement = createLeafTitleSpan(name);
      const titleElement = createLeafTitleElement();
      const iconElement = createLeafIconElement();
      const checkboxElement = createCheckboxElement(name, code, multipleChoice);

      bindCheckboxAction(checkboxElement, displayNameElement);

      const classValue = ['item', `level-${level}`]
      const chosenNodes = $input.val().split(',');
      if (chosenNodes.some(chosenCode => chosenCode === code)) {
        classValue.push('active');
      }

      const leafElement = $('<div class="' + classValue.join(' ') + '"></div>');
      const leafContentElement = createLeafContentElement();

      leafElement.append(iconElement);
      titleElement.append(displayNameElement);
      titleElement.append(checkboxElement);
      leafContentElement.append(titleElement);

      if (!hasChildren) {
        iconElement.addClass('outline');
      }
      if (hasChildren) {
        bindExpandLeafAction(code, leafContentElement, iconElement, level);
        iconElement.css('cursor', 'pointer');
      }
      leafElement.append(leafContentElement);

      return leafElement;
    };
    createLeafFunc = createLeaf;

    const insertRoots = function createRootNode(elements, rootContainer) {
      const rootTabHeaders = createRootTabHeadersContainer();
      rootContainer.append(rootTabHeaders);

      elements.forEach((rootNode, index) => {
        const header = createRootTabHeader(rootNode.code);
        header.data('tab', rootNode.code);

        const tab = createRootTab(rootNode.code);
        const tabItemsList = createRootTabItemsContainer();
        tabItemsList.append(createLeafFunc(rootNode.name, rootNode.code, rootNode.hasChildren, multiple, rootNode.level));
        tab.append(tabItemsList);
        tab.data('tab', rootNode.code);

        if (index === 0) {
          header.addClass('active');
          tab.addClass('active');
        }
        let rootName = rootNode.name;
        if (rootName === 'Produkty dla klienta detalicznego') {
          rootName = 'Detalista';
        } else if (rootName === 'Produkty dla architekta') {
          rootName = 'Architekt';
        }
        header.html(`${rootName} (<span class="taxonomy-dynamic-list-counter-${rootNode.code}">${tab.find(':checked').length}</span>)`);

        rootTabHeaders.append(header);
        rootContainer.append(tab);
      });

      tree.append(rootContainer);
      rootTabHeaders.find('.item').tab();

      loader.removeClass('active');
    };

    const preloadedRootNodes = getPreLoadedNodes('root');
    if (Array.isArray(preloadedRootNodes)) {
      const rootContainer = createRootContainer();
      insertRoots(preloadedRootNodes, rootContainer);
    } else {
      tree.api({
        on: 'now',
        method: 'GET',
        url: tree.data('tree-root-nodes-url') || tree.data('taxon-root-nodes-url'),
        cache: false,
        beforeSend(settings) {
          loader.addClass('active');

          return settings;
        },
        onSuccess(response) {
          const rootContainer = createRootContainer();
          insertRoots(response, rootContainer);
        },
      });
    }
  },
});
